import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { compose } from 'recompose'
import {
  Table,
    TableHead,
    TableRow,
    TableCell
} from 'react-toolbox'
import { NVQUAL_TESTS, NVQUAL_TEST_CATEGORIES } from 'containers/NvqualReport/constants'
import T from 'i18n-react'

import { Link, Element } from 'react-scroll'


class TestSummary extends Component {

  getErrorsCount(errors){
      return errors.filter(error => error.classification == "error").length
  }

  getWarningsCount(errors){
    return errors.filter(error => error.classification == "warning").length
}

    renderResultCell(result){
        return result === "Pass" ? <code className={styles.green}>{result}</code> : <code className={styles.red}>{result}</code>
    }

  renderTableRow (tests) {
    const filteredTestNames = Object.values(NVQUAL_TESTS).filter(testName => tests.filter(t => testName == t.testName).length > 0)
    
    return filteredTestNames.map((testName, idx) => {
        const test = tests.find(t => t.testName == testName)

        return (
        <TableRow key={idx}>
            <TableCell key={`testName${test.createdAt}${idx}`}>
              <Link activeClass="active" to={test.testName} spy={true} smooth={true} offset={0} duration={200} containerId="scrollContainer">
                <span className={styles.link}>{T.translate(`containers.project.nvqualSection.test.${test.testName}`)}</span>
              </Link>
            </TableCell>
            <TableCell key={`errorNum${test.createdAt}${idx}`}>{this.getErrorsCount(test.error)}</TableCell>
            <TableCell key={`warningNum${test.createdAt}${idx}`}>{this.getWarningsCount(test.error)}</TableCell>
            <TableCell key={`result${test.createdAt}${idx}`}>{this.renderResultCell(test.result)}</TableCell>
        </TableRow>
    )})
  }

  renderTableHead () {
    return (
        <TableHead key={`head`}>
            <TableCell key={`testName`}>Test Name</TableCell>
            <TableCell key={`errorNum`}>Number of Errors</TableCell>
            <TableCell key={`warningNum`}>Number of Warnings</TableCell>
            <TableCell key={`result`}>Result</TableCell>
        </TableHead>
    )
  }

  render(){
    const { tests } = this.props

    return(
      <Table selectable={false}>
          {this.renderTableHead()}
          {this.renderTableRow(tests)}
      </Table>
    )
  }
}

const withStyles = CSSModules(styles)
const enhance = compose(withStyles)
export default enhance(TestSummary)
